import { ColoursObj } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { Typography } from '@eventr/common-storybook'
import { ReactNode } from 'react'

interface IHeaderTitleProps {
    title: string
    textColor?: string
    iconElement: ReactNode
    fontVariant?: 'bodyRegular' | 'bodyBold' | 'mobileH1'
}
export const HeaderTitle = ({
    title,
    textColor,
    fontVariant = 'bodyBold',
    iconElement,
}: IHeaderTitleProps) => {
    return (
        <Stack flexDirection="row" alignItems={'center'} gap="16px">
            {iconElement}
            <Typography
                variant={fontVariant}
                color={textColor ?? ColoursObj.core.primary}
            >
                {title}
            </Typography>
        </Stack>
    )
}
